import { render, staticRenderFns } from "./NewCommentNotificationsCounter.vue?vue&type=template&id=3fec3ba2&scoped=true&"
import script from "./NewCommentNotificationsCounter.vue?vue&type=script&lang=js&"
export * from "./NewCommentNotificationsCounter.vue?vue&type=script&lang=js&"
import style0 from "./NewCommentNotificationsCounter.vue?vue&type=style&index=0&id=3fec3ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fec3ba2",
  null
  
)

export default component.exports